export default __webpack_public_path__ + "d7bd2ce1e7c22c5afe9714a98338e852.svg";